import React from 'react';

class IconTwitterComponent extends React.Component {
  render() {
    const { className, color = 'currentColor' } = this.props;

    return (
      <svg
        className={className}
        width="24"
        height="16"
        viewBox="0 0 24 16"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <path
          d="M12.237-.001c1.294.005 7.466.05 9.138.477 1.033.262 1.845 1.036 2.123 2.02.5 1.783.5 5.503.5 5.503v.011c0 .22-.016 3.763-.5 5.49-.278.983-1.09 1.758-2.123 2.021-1.712.437-8.14.474-9.222.477h-.31c-1.082-.003-7.51-.04-9.22-.477C1.588 15.258.775 14.483.5 13.5.045 11.885.002 8.68-.002 8.092v-.187C.002 7.318.045 4.111.5 2.496.776 1.512 1.588.738 2.622.476 4.294.05 10.465.004 11.76 0zm-2.639 4.57v6.857l6.235-3.428-6.235-3.43z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default IconTwitterComponent;
